const STORAGE_KEY = 'webdownstatus_history_v1';
const MAX_ITEMS = 500;

export function getHistory() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Failed to load history:', error);
    return [];
  }
}

export function addToHistory(entry) {
  try {
    const history = getHistory();
    
    // Add timestamp and ID if not present
    const historyEntry = {
      ...entry,
      id: entry.id || Date.now().toString(),
      timestamp: entry.timestamp || new Date().toISOString()
    };

    // Add to beginning of array
    history.unshift(historyEntry);

    // Keep only the last MAX_ITEMS entries
    if (history.length > MAX_ITEMS) {
      history.splice(MAX_ITEMS);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    return history;
  } catch (error) {
    console.error('Failed to save to history:', error);
    return getHistory();
  }
}

export function clearHistory() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear history:', error);
  }
}

export function removeFromHistory(id) {
  try {
    const history = getHistory();
    const filtered = history.filter(item => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    return filtered;
  } catch (error) {
    console.error('Failed to remove from history:', error);
    return getHistory();
  }
}

export function getHistoryByDomain(domain) {
  const history = getHistory();
  return history.filter(item => {
    try {
      const url = new URL(item.normalizedUrl || item.finalUrl);
      return url.hostname === domain;
    } catch {
      return false;
    }
  });
}